import { Action, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import chatFrameSlice, { chatFrameActions } from './chatFrameSlice';
import querySlice, { queryActions } from './querySlice';
import { sendQuery } from './thunk';

const store = configureStore({
    reducer: {
        chatFrameSlice: chatFrameSlice.reducer,
        querySlice: querySlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
export { chatFrameSlice, querySlice };
export default store;
export type ChatBlkState = ReturnType<typeof store.getState>;
export type ChatBlkDispatch = typeof store.dispatch;
export type ChatBlkThunkDispatch = ThunkDispatch<ChatBlkState, unknown, Action>;
export { sendQuery, chatFrameActions, queryActions };
